// Mapping between procedures and after-visit care guides
// This enables bidirectional linking between procedure articles and aftercare instructions

export const procedureToAfterVisit = {
  // Stone Procedures
  'ureteroscopy': { afterVisitId: 'post-ureteroscopy', afterVisitTitle: 'Post-Ureteroscopy Care' },
  'laser-lithotripsy': { afterVisitId: 'post-ureteroscopy', afterVisitTitle: 'Post-Ureteroscopy Care' },
  'eswl': { afterVisitId: 'post-eswl', afterVisitTitle: 'Post-ESWL Care' },
  'shockwave': { afterVisitId: 'post-eswl', afterVisitTitle: 'Post-ESWL Care' },
  'pcnl': { afterVisitId: 'post-pcnl', afterVisitTitle: 'Post-PCNL Care' },
  'nephrolithotomy': { afterVisitId: 'post-pcnl', afterVisitTitle: 'Post-PCNL Care' },
  
  // Prostate Procedures
  'turp': { afterVisitId: 'post-prostate-outlet-surgery', afterVisitTitle: 'Post-Prostate Outlet Surgery Care' },
  'greenlight': { afterVisitId: 'post-prostate-outlet-surgery', afterVisitTitle: 'Post-Prostate Outlet Surgery Care' },
  'holep': { afterVisitId: 'post-prostate-outlet-surgery', afterVisitTitle: 'Post-Prostate Outlet Surgery Care' },
  'rezum': { afterVisitId: 'post-prostate-outlet-surgery', afterVisitTitle: 'Post-Prostate Outlet Surgery Care' },
  'urolift': { afterVisitId: 'post-prostate-outlet-surgery', afterVisitTitle: 'Post-Prostate Outlet Surgery Care' },
  'aquablation': { afterVisitId: 'post-prostate-outlet-surgery', afterVisitTitle: 'Post-Prostate Outlet Surgery Care' },
  'prostatectomy': { afterVisitId: 'post-prostatectomy', afterVisitTitle: 'Post-Radical Prostatectomy Care' },
  'prostate-biopsy': { afterVisitId: 'prostate-biopsy', afterVisitTitle: 'Prostate Biopsy Aftercare' },
  
  // Bladder Procedures
  'cystoscopy': { afterVisitId: 'cystoscopy', afterVisitTitle: 'Cystoscopy Aftercare' },
  'turbt': { afterVisitId: 'post-turbt', afterVisitTitle: 'Post-TURBT / Bladder Biopsy Care' },
  'bladder-biopsy': { afterVisitId: 'post-turbt', afterVisitTitle: 'Post-TURBT / Bladder Biopsy Care' },
  'cystectomy': { afterVisitId: 'post-cystectomy', afterVisitTitle: 'Post-Radical Cystectomy Care' },
  'bcg': { afterVisitId: 'post-bcg', afterVisitTitle: 'BCG Therapy Aftercare' },
  
  // Kidney Procedures
  'nephrectomy': { afterVisitId: 'post-partial-nephrectomy', afterVisitTitle: 'Post-Partial Nephrectomy Care' },
  'partial-nephrectomy': { afterVisitId: 'post-partial-nephrectomy', afterVisitTitle: 'Post-Partial Nephrectomy Care' },
  'kidney-ablation': { afterVisitId: 'post-kidney-ablation', afterVisitTitle: 'Post-Kidney Ablation Care' },
  'cryoablation': { afterVisitId: 'post-kidney-ablation', afterVisitTitle: 'Post-Kidney Ablation Care' },
  'radiofrequency': { afterVisitId: 'post-kidney-ablation', afterVisitTitle: 'Post-Kidney Ablation Care' },
  
  // Men's Health Procedures
  'vasectomy': { afterVisitId: 'vasectomy', afterVisitTitle: 'Vasectomy Aftercare' },
  'orchiectomy': { afterVisitId: 'post-orchiectomy', afterVisitTitle: 'Post-Orchiectomy Care' },
  'hydrocelectomy': { afterVisitId: 'post-hydrocelectomy', afterVisitTitle: 'Post-Hydrocelectomy Care' },
  'hydrocele': { afterVisitId: 'post-hydrocelectomy', afterVisitTitle: 'Post-Hydrocelectomy Care' },
  'spermatocelectomy': { afterVisitId: 'post-spermatocelectomy', afterVisitTitle: 'Post-Spermatocelectomy Care' },
  'spermatocele': { afterVisitId: 'post-spermatocelectomy', afterVisitTitle: 'Post-Spermatocelectomy Care' },
  'varicocelectomy': { afterVisitId: 'post-varicocelectomy', afterVisitTitle: 'Post-Varicocelectomy Care' },
  'circumcision': { afterVisitId: 'post-circumcision', afterVisitTitle: 'Post-Circumcision Care' },
  
  // Catheter/Device Related
  'catheter': { afterVisitId: 'urinary-retention-catheter', afterVisitTitle: 'Catheter Care Instructions' },
  'stent': { afterVisitId: 'ureteral-stent', afterVisitTitle: 'Ureteral Stent Care' },
  'suprapubic': { afterVisitId: 'suprapubic-catheter', afterVisitTitle: 'Suprapubic Catheter Care' },
  'nephrostomy': { afterVisitId: 'nephrostomy-tube', afterVisitTitle: 'Nephrostomy Tube Care' }
};

// Reverse mapping: After-visit guides to related procedure articles
export const afterVisitToProcedure = {
  'post-ureteroscopy': {
    procedureKeywords: ['Ureteroscopy', 'Laser Lithotripsy'],
    procedureTitle: 'Ureteroscopy & Laser Lithotripsy',
    searchPath: '/procedures'
  },
  'post-eswl': {
    procedureKeywords: ['ESWL', 'Shockwave', 'Lithotripsy'],
    procedureTitle: 'ESWL (Shockwave Lithotripsy)',
    searchPath: '/procedures'
  },
  'post-pcnl': {
    procedureKeywords: ['PCNL', 'Nephrolithotomy', 'Percutaneous'],
    procedureTitle: 'PCNL (Percutaneous Nephrolithotomy)',
    searchPath: '/procedures'
  },
  'post-prostate-outlet-surgery': {
    procedureKeywords: ['TURP', 'GreenLight', 'Aquablation', 'Rezum', 'UroLift', 'HoLEP', 'BPH Treatment'],
    procedureTitle: 'BPH / Prostate Outlet Surgery',
    searchPath: '/procedures'
  },
  'post-prostatectomy': {
    procedureKeywords: ['Prostatectomy', 'Prostate Cancer Surgery'],
    procedureTitle: 'Radical Prostatectomy',
    searchPath: '/procedures'
  },
  'prostate-biopsy': {
    procedureKeywords: ['Prostate Biopsy'],
    procedureTitle: 'Prostate Biopsy',
    searchPath: '/procedures'
  },
  'cystoscopy': {
    procedureKeywords: ['Cystoscopy'],
    procedureTitle: 'Cystoscopy',
    searchPath: '/procedures'
  },
  'post-turbt': {
    procedureKeywords: ['TURBT', 'Bladder Biopsy', 'Bladder Tumor'],
    procedureTitle: 'TURBT / Bladder Biopsy',
    searchPath: '/procedures'
  },
  'post-cystectomy': {
    procedureKeywords: ['Cystectomy', 'Bladder Removal'],
    procedureTitle: 'Radical Cystectomy',
    searchPath: '/procedures'
  },
  'post-bcg': {
    procedureKeywords: ['BCG', 'Bladder Cancer Treatment'],
    procedureTitle: 'BCG Immunotherapy',
    searchPath: '/procedures'
  },
  'post-partial-nephrectomy': {
    procedureKeywords: ['Partial Nephrectomy', 'Kidney Surgery'],
    procedureTitle: 'Partial Nephrectomy',
    searchPath: '/procedures'
  },
  'post-kidney-ablation': {
    procedureKeywords: ['Ablation', 'Cryoablation', 'Radiofrequency'],
    procedureTitle: 'Kidney Tumor Ablation',
    searchPath: '/procedures'
  },
  'vasectomy': {
    procedureKeywords: ['Vasectomy'],
    procedureTitle: 'Vasectomy',
    searchPath: '/procedures'
  },
  'post-orchiectomy': {
    procedureKeywords: ['Orchiectomy', 'Testicular Cancer'],
    procedureTitle: 'Orchiectomy',
    searchPath: '/procedures'
  },
  'post-hydrocelectomy': {
    procedureKeywords: ['Hydrocele', 'Hydrocelectomy'],
    procedureTitle: 'Hydrocelectomy',
    searchPath: '/procedures'
  },
  'post-spermatocelectomy': {
    procedureKeywords: ['Spermatocele', 'Spermatocelectomy'],
    procedureTitle: 'Spermatocelectomy',
    searchPath: '/procedures'
  },
  'post-varicocelectomy': {
    procedureKeywords: ['Varicocele', 'Varicocelectomy'],
    procedureTitle: 'Varicocele Repair',
    searchPath: '/conditions'
  },
  'post-circumcision': {
    procedureKeywords: ['Circumcision'],
    procedureTitle: 'Adult Circumcision',
    searchPath: '/procedures'
  },
  'ureteral-stent': {
    procedureKeywords: ['Stent', 'Ureteroscopy'],
    procedureTitle: 'Ureteral Stent Placement',
    searchPath: '/procedures'
  },
  'urinary-retention-catheter': {
    procedureKeywords: ['Catheter', 'Urinary Retention'],
    procedureTitle: 'Foley Catheter Placement',
    searchPath: '/conditions'
  },
  'suprapubic-catheter': {
    procedureKeywords: ['Suprapubic'],
    procedureTitle: 'Suprapubic Catheter',
    searchPath: '/procedures'
  },
  'nephrostomy-tube': {
    procedureKeywords: ['Nephrostomy', 'PCNL'],
    procedureTitle: 'Nephrostomy Tube Placement',
    searchPath: '/procedures'
  },
  'self-catheterization': {
    procedureKeywords: ['Catheterization', 'Neurogenic Bladder'],
    procedureTitle: 'Clean Intermittent Catheterization',
    searchPath: '/conditions'
  },
  'catheter-removal': {
    procedureKeywords: ['Catheter'],
    procedureTitle: 'Catheter Care',
    searchPath: '/procedures'
  },
  // Condition-Related Follow-Up Guides (link to Conditions, not Procedures)
  'kidney-stone-conservative': {
    procedureKeywords: ['Kidney Stone', 'Stone Prevention'],
    procedureTitle: 'Kidney Stone Prevention',
    searchPath: '/conditions'
  },
  'kidney-stone-ed-followup': {
    procedureKeywords: ['Kidney Stone', 'Stone'],
    procedureTitle: 'Kidney Stones',
    searchPath: '/conditions'
  },
  'elevated-psa': {
    procedureKeywords: ['PSA', 'Elevated PSA'],
    procedureTitle: 'Elevated PSA',
    searchPath: '/conditions'
  },
  'bph': {
    procedureKeywords: ['BPH', 'Enlarged Prostate', 'Benign Prostatic'],
    procedureTitle: 'BPH (Enlarged Prostate)',
    searchPath: '/conditions'
  },
  'hematuria': {
    procedureKeywords: ['Hematuria', 'Blood in Urine'],
    procedureTitle: 'Hematuria (Blood in Urine)',
    searchPath: '/conditions'
  },
  'recurrent-uti': {
    procedureKeywords: ['UTI', 'Urinary Tract Infection'],
    procedureTitle: 'Urinary Tract Infections',
    searchPath: '/conditions'
  },
  'erectile-dysfunction': {
    procedureKeywords: ['Erectile Dysfunction', 'ED'],
    procedureTitle: 'Erectile Dysfunction',
    searchPath: '/conditions'
  },
  'testicular-pain': {
    procedureKeywords: ['Testicular Pain', 'Scrotal'],
    procedureTitle: 'Testicular Pain',
    searchPath: '/conditions'
  },
  'active-surveillance-prostate': {
    procedureKeywords: ['Active Surveillance', 'Prostate Cancer'],
    procedureTitle: 'Active Surveillance for Prostate Cancer',
    searchPath: '/cancers'
  }
};

// Helper function to find after-visit guide for a procedure article
export const findAfterVisitForArticle = (articleTitle) => {
  const titleLower = articleTitle.toLowerCase();
  
  for (const [keyword, link] of Object.entries(procedureToAfterVisit)) {
    if (titleLower.includes(keyword.toLowerCase())) {
      return link;
    }
  }
  return null;
};

// Helper function to find procedure info for an after-visit guide
export const findProcedureForAfterVisit = (afterVisitId) => {
  return afterVisitToProcedure[afterVisitId] || null;
};
